// extracted by mini-css-extract-plugin
export default {"partnerEntry":"Footer_partnerEntry__GKRli","partnerLink":"Footer_partnerLink__wEUkt"};